import React from 'react'
import ReactModal from 'react-modal'
import JobDetails from './JobDetails'
import workflowsManager from '../requests/workflows'
import _last from 'lodash/last'
const ReactDataGrid = require('react-data-grid')
const { Toolbar, Data: { Selectors } } = require('react-data-grid-addons')

class DataGrid extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rows: this.props.rows,
      headers: this.props.headers,
      selectedRows: [],
      selectedIndexes: [],
      filters: {},
      expanded: {},
      sortColumn: null,
      sortDirection: null,
      loading: false,
      showModal: false,
      modalContent:''
    }
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onRowClick = this.onRowClick.bind(this)
  }
  handleCloseModal () {
    this.setState({ showModal: false });
  }
  onRowClick(rowIndex, job, gridData){
    // gte workflkows by job id
    console.log(job)
    if (job) {
      workflowsManager.getWokflowsByJobId(job.job_id).then((workflkows)=>{
        console.log(workflkows)
        job.workflkows = workflkows
        this.setState({ showModal: true, modalContent: job})
      })
    }
  }
  rowGetter = (index) => {
    return Selectors.getRows(this.state)[index];
  };

  rowsCount = () => {
    return Selectors.getRows(this.state).length;
  };

  handleFilterChange = (filter) => {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  };

  getValidFilterValues = (columnId) => {
    let values = this.state.rows.map(r => r[columnId]);
    return values.filter((item, i, a) => { return i === a.indexOf(item); });
  };

  handleOnClearFilters = () => {
    this.setState({ filters: {} });
  };

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
  };

  getSubRowDetails = (rowItem) => {
    let isExpanded = this.state.expanded[rowItem.name] ? this.state.expanded[rowItem.name] : false;
    return {
      group: rowItem.children && rowItem.children.length > 0,
      expanded: isExpanded,
      children: rowItem.children,
      field: 'workflow',
      treeDepth: rowItem.treeDepth || 0,
      siblingIndex: rowItem.siblingIndex,
      numberSiblings: rowItem.numberSiblings
    };
  };

  onCellExpand = (args) => {
    console.log(args);
    let rows = this.state.rows.slice(0);
    let rowKey = args.rowData.name;
    let rowIndex = rows.indexOf(args.rowData);
    let subRows = args.expandArgs.children;
    let expanded = Object.assign({}, this.state.expanded);
    if (expanded && !expanded[rowKey]) {  // adding item if no expanded the selected row
      expanded[rowKey] = true;
      this.updateSubRowDetails(subRows, args.rowData.treeDepth);
      rows.splice(rowIndex + 1, 0, ...subRows);
    } else if (expanded[rowKey]) { // removing the children row whe selected the expande for the same master job row
      expanded[rowKey] = false;
      rows.splice(rowIndex + 1, subRows.length);
    }

    this.setState({ expanded: expanded, rows: rows });
  };

  updateSubRowDetails = (subRows, parentTreeDepth) => {
    let treeDepth = parentTreeDepth || 0;
    subRows.forEach((sr, i) => {
      sr.treeDepth = treeDepth + 1;
      sr.siblingIndex = i;
      sr.numberSiblings = subRows.length;
    });
  };
  componentDidUpdate(prevProps) {
    // const lastPrevJob = (prevProps) ? _last(prevProps.rows) : null
    // console.log('lastPrevJob', prevProps)
    // const currentLastJob = _last(this.props.rows)
    // console.log('currentProps', this.props)
    if (prevProps.rows.length !== this.props.rows.length) {
      this.setState({rows: this.props.rows})
    }
  }
  render() {
    if(this.state.loading){
      return (<div> loading data</div>)
    }
    return (
      <div>
        <ReactModal
           className = 'ms-modal'
           overlayClassName='ms-overlay'
           isOpen={this.state.showModal}
           contentLabel="Job Details"
        >
          <button type="button" className="btn btn-danger pull-right" aria-label="Close" onClick={this.handleCloseModal}>
            <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
          </button>
          <JobDetails job = {this.state.modalContent}/>
          <div className="text-center">
            <button className='btn btn-danger' onClick={this.handleCloseModal}>Close</button>
          </div>
        </ReactModal>
         <ReactDataGrid
          ref = { node => this.grid = node }
          rowKey = "id"
          onGridSort={ this.handleGridSort }
          columns = { this.props.headers }
          rowGetter = { this.rowGetter }
          onRowClick={ this.onRowClick }
          rowsCount = { this.rowsCount() }
          minHeight = {600}
          // onCellExpand={this.onCellExpand}
          // getSubRowDetails={this.getSubRowDetails}
          toolbar = {
          <Toolbar enableFilter={true}>
            <label className='ml5'> Items: {this.rowsCount()} </label>
          </Toolbar> }
          onAddFilter = { this.handleFilterChange }
          getValidFilterValues = { this.getValidFilterValues }
          onClearFilters = { this.handleOnClearFilters }/>
      </div>
    );
  }
}

export default DataGrid;


// WEBPACK FOOTER //
// ./src/components/DataGrid.js